import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/footer/PRSE__Logo.png")